import lazyLoad from "@loadable/component";
import createPlugin from "./createPlugin";
import TripleHeroRenderer from "./Renderer";

const TripleHeroForm = lazyLoad(() => import("./Form"));

const TripleHeroPlugin = (settings) =>
    createPlugin({
        Renderer: TripleHeroRenderer,
        Controls: TripleHeroForm,
        ...settings,
    });

const TripleHero = TripleHeroPlugin();
export default TripleHero;

export { TripleHeroPlugin, TripleHeroRenderer };
